import { render } from "./NavegacionCliente.vue?vue&type=template&id=108b80c4"
import script from "./NavegacionCliente.vue?vue&type=script&lang=js"
export * from "./NavegacionCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__